module.exports = __webpack_public_path__ + "img/round-arrow-right-hover-transparent.667400e4.svg";